import {
  ERROR_ALERT,
  INFO_ALERT,
  SUCCESS_ALERT,
  WARNING_ALERT,
} from "../actions/commonAction";

const initialState = {
  fields: [],
};

const commonReducer = (state = initialState, action) => {

  switch (action.type) {
    case SUCCESS_ALERT:
      return {
        ...state,
        alertType: "success",
        alertMessage: action.payload,
      };
    case ERROR_ALERT:
      return {
        ...state,
        alertType: "error",
        alertMessage: action.payload,
      };
    case WARNING_ALERT:
      return {
        ...state,
        alertType: "warning",
        alertMessage: action.payload,
      };
    case INFO_ALERT:
      return {
        ...state,
        alertType: "info",
        alertMessage: action.payload,
      };

    default:
      return {
        ...state,
        alertType: null,
        alertMessage: null,
      };
  }
};

export default commonReducer;
